module.exports = __webpack_public_path__ + "img/fb-map.3c910e5e.svg";